import useAction from '@shared/hooks/useAction';
import { useSelector } from 'react-redux';
import { Reducer } from 'redux';
import { createSelector } from 'reselect';

const initialState = { isVisible: false };
type State = typeof initialState;

const TOGGLE_HELP_VISIBILITY = 'TOGGLE_HELP_VISIBILITY';

const toggleHelpVisibility = (visible: boolean) =>
  ({ type: TOGGLE_HELP_VISIBILITY, data: visible }) as const;

type Action = ReturnType<typeof toggleHelpVisibility>;

const help: Reducer<State, Action> = (state = initialState, action) => {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case TOGGLE_HELP_VISIBILITY:
      return {
        ...state,
        isVisible: action.data,
      };
    default:
      return state;
  }
};

export default help;

// SELECTORS

const rootSelector = (rootState: { help: State }) => rootState.help;
const isHelpVisibleSelector = createSelector(rootSelector, (state) => state.isVisible);
export const useIsHelpVisible = () => useSelector(isHelpVisibleSelector);

export const useToggleHelpVisibility = () => useAction(toggleHelpVisibility);
